import styled from "styled-components";
import { ReactSVG } from "react-svg";

export const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
`;

export const Icon = styled(ReactSVG)`
  svg {
    display: block;
    width: 1em;
    height: 1em;
    font-size: 2rem;
    fill: currentColor;
    transition: ${({ theme }) => theme.transition};
    transition-property: fill;
  }
`;
